/**
 * @generated SignedSource<<ccee22281552559a37c58503e7bfefd3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type QueriesDocumentVersionsFromSchemaQuery$variables = {
  at?: string | null;
  schemaIds?: ReadonlyArray<number> | null;
};
export type QueriesDocumentVersionsFromSchemaQuery$data = {
  readonly documentVersions: ReadonlyArray<{
    readonly document: {
      readonly _id: number;
    };
    readonly json: any;
  } | null>;
};
export type QueriesDocumentVersionsFromSchemaQuery = {
  response: QueriesDocumentVersionsFromSchemaQuery$data;
  variables: QueriesDocumentVersionsFromSchemaQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "at"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schemaIds"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "at",
        "variableName": "at"
      },
      {
        "kind": "Variable",
        "name": "schemaIds",
        "variableName": "schemaIds"
      }
    ],
    "concreteType": "DocumentVersion",
    "kind": "LinkedField",
    "name": "documentVersions",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Document",
        "kind": "LinkedField",
        "name": "document",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "_id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "QueriesDocumentVersionsFromSchemaQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "QueriesDocumentVersionsFromSchemaQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "02dfe429a7ab995ef93c3f3bae09dd55",
    "id": null,
    "metadata": {},
    "name": "QueriesDocumentVersionsFromSchemaQuery",
    "operationKind": "query",
    "text": "query QueriesDocumentVersionsFromSchemaQuery(\n  $schemaIds: [Int!]\n  $at: DateTime\n) {\n  documentVersions(schemaIds: $schemaIds, at: $at) {\n    json\n    document {\n      _id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "86dfadd2227f64dc24fa3bf200e3c01c";

export default node;
